export const FETCH_RESERVE = "FETCH_RESERVE";
export const FETCH_RESERVE_START = "FETCH_RESERVE_START";
export const FETCH_RESERVE_SUCCESS = "FETCH_RESERVE_SUCCESS";
export const FETCH_RESERVE_ERROR = "FETCH_RESERVE_ERROR";

export const ADD_UPDATE_RESERVE_EVENT = "ADD_UPDATE_RESERVE_EVENT";
export const ADD_UPDATE_RESERVE_EVENT_START = "ADD_UPDATE_RESERVE_EVENT_START";
export const ADD_UPDATE_RESERVE_EVENT_SUCCESS = "ADD_UPDATE_RESERVE_EVENT_SUCCESS";
export const ADD_UPDATE_RESERVE_EVENT_ERROR = "ADD_UPDATE_RESERVE_EVENT_ERROR";

export const DELETE_RESERVE_EVENT = "DELETE_RESERVE_EVENT";
export const DELETE_RESERVE_EVENT_START = "DELETE_RESERVE_EVENT_START";
export const DELETE_RESERVE_EVENT_SUCCESS = "DELETE_RESERVE_EVENT_SUCCESS";
export const DELETE_RESERVE_EVENT_ERROR = "DELETE_RESERVE_EVENT_ERROR";


export const fetchReserve = (payload) => {
  return {
      type: FETCH_RESERVE,
      payload
  };
};

export const addUpdateReserveEvent = (event) => {
  return {
      type: ADD_UPDATE_RESERVE_EVENT,
      payload: {
          event
      }
  };
};